import React from 'react';
import '../less/Slider.less';
import {Link, Slider} from 'MWC';
import { environment } from "../../../../environment/environment";
import DOMPurify from 'utils/sanitize';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';

export default function template() {

    const { isMobile, lang, widget, hardSlide, formAnalytics, page, award, mobileTop, awardSlideId,
    posEconomySlideId, modalSlideId, withUtmMarks } = this.props,
      sortedWidget = filterByEnvironment(widget.data),
      slides = widget.data ? sortedWidget.sort((a, b) => a.order - b.order).map((item, index) => {
        const bgImage = isMobile ? this.changeFilesUrl(item.img_mobile) : this.changeFilesUrl(item.img_desktop);
        const itemHeight = item.height_px ? item.height_px : 0;
        const showAward = award && (!awardSlideId || item.id === awardSlideId);

        const shouldOpenPosEconomyModal = item.id === posEconomySlideId && (!isMobile || withUtmMarks);
        const shouldOpenModal = shouldOpenPosEconomyModal || item.id === modalSlideId;
        return (
          <div 
            className={`slide slider-main `} 
            key={item.id} 
            style={{background: `url(${bgImage}) center / contain no-repeat`, backgroundSize:'cover'}}           
            id={`slide-${index + 1} ${page ? `${page}` : ''}`}
          >
            <div className='slide-content' style={{
                ...(isMobile
                    ? { justifyContent: "start" }
                    : item.height_px_desk
                    ? { alignItems: "start" }
                    : { alignItems: "center" }),
              }}>
              <div className='green-content' style={{
                  marginTop: isMobile
                    ? `${item.height_px_mob || mobileTop || 100}px`
                    : `${item.height_px_desk || 0}px`
                }}>
                <h1
                  className="slider-main-head"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(isMobile ? item.title_ua_mobile : item.title_ua),
                  }}
                ></h1>
                <div className='slider-desc'
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(isMobile ? item.desc_mobile : item.desc_desktop),
                  }}
                ></div>
                  {item.btn_status ?
                    <div className='slider-info'>
                      <Link 
                          href={
                              shouldOpenModal || item.btn_path === '#credit-calculator'
                                  ? ''
                                  : (item.btn_path ? item.btn_path : this.changeFilesUrl(item.btn_file))
                          }
                          target="_self"
                          onClick={
                              shouldOpenModal || item.btn_path === '#credit-calculator'
                                  ? (e) => e.preventDefault()
                                  : undefined
                          }
                      >
                          <button
                              className={`${item.button_white ? 'btn-transparent' : 'btn-black'} ${formAnalytics ? 'form-open' : ''}`}
                              onClick={() => {
                                  if (shouldOpenModal) {
                                      this.props.toggleModal && this.props.toggleModal();
                                  } else if (item.btn_path === '#credit-calculator') {
                                      this.props.toggleModal && this.props.toggleModal(false);
                                  }
                              }}
                              id={`${page ? page : ''} slide-button-${item.id ? item.id : ''}`}
                          >
                              {item.button_title ? item.button_title : this.l10n('BANNER_CASHBACK_OSGPO_BUTTON')}
                          </button>
                      </Link>
                    </div>
                  : ''}
              </div>
            </div>
            <div className="footnote"        
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(item.share_ua),
              }}
            ></div>            
            {showAward ?
              (<a className="award-block" href={award.link} rel="noopener noreferrer" target='_blank'>
                <img src={award.img} alt={this.l10n(award.text)} className="award-block-image"/>
                <div className="award-block-content">
                  <div className="award-block-title">{this.l10n(award.title)}</div>
                  <div className="award-block-text">{this.l10n(award.text)}</div>
                </div>
              </a>) : ''
            }
          </div>
        )
      }) : [];
    return (
      <div className='side-a slider-wrapper'>
        <Slider
          autoPlayInterval={15000000}
          autoPlay
          showNavigation={slides.length > 1}
          showArrows={slides.length > 1}
        >
          {slides}
        </Slider>
      </div>
    );
}
